<template>
	<div v-if="core == 1 || (available && available.length > 0)" class="inStockMessage">
		<span v-if="(available && available.length > 0)" >
			<img src="@/assets/img/tick.png" alt="Tick" class="stockTick"> 
			Stock available at Cherrytree
		</span>
		<div style="display:none;" class="temporaryChristmasText" v-if="isChristmasSeason && (available && available.length > 0)">
			Due to seasonal high demand, this item may not be available in stock. If urgent, please email <a href="member@cherrytree.co.nz ">Member Services Team</a> to check availability.
		</div>
		<span v-if="core == 1">
			Wellington Showroom Core Stock
		</span>
		<MoreInfoPopover 
			class="stock-popover" 
			width="auto"
			v-if="core == 1"
		>
			This product is part of the Wellington Showroom core stock range, so is usually available to be shipped or collected when we receive your order. If we do not have stock due to an unpredicted fluctuation in sales, next orders will usually be placed twice monthly.
		</MoreInfoPopover>
	</div>
</template>

<script>

import MoreInfoPopover from "@/components/MoreInfoPopover";

export default {
	name: "ProductInStock",
	props: [ "core", "available" ],
	components: {
		MoreInfoPopover,
	},
	computed: {
		isChristmasSeason() {
			let currentDate = new Date();
			return currentDate.getMonth() == 11 && currentDate.getDate() < 26; 
		}
	}
}
</script>

<style lang="scss" scoped>
	.inStockMessage {
		color: $CTgreen;
		font-weight: bold;
	}

	.temporaryChristmasText {
		margin-top: 10px;
		color: $CTred;
		font-weight: bold;
	}

</style>
